import React from 'react';
import styles from 'sections/heroPage/hero/hero.module.css';
import {
    getMobileSrc2x,
    getMobileSrc3x,
    getMobileSrcWebp,
    getMobileSrcWebp2x,
    getMobileSrcWebp3x,
} from 'utils/imageResize.utils';

export const ImgBackground = () => {
    const mobileSrc =
        'https://femme-general.s3.eu-north-1.amazonaws.com/mainMobile/mobileBg%401x.png';
    const mobileSrc2x = getMobileSrc2x(mobileSrc);
    const mobileSrc3x = getMobileSrc3x(mobileSrc);

    const mobileSrcWebp = getMobileSrcWebp(mobileSrc);
    const mobileSrcWebp2x = getMobileSrcWebp2x(mobileSrcWebp);
    const mobileSrcWebp3x = getMobileSrcWebp3x(mobileSrcWebp);

    return (
        <picture>
            <source
                type="image/webp"
                media="(max-width: 600px)"
                srcSet={`${mobileSrcWebp} 1x, ${mobileSrcWebp2x} 2x, ${mobileSrcWebp3x} 3x`}
                sizes="(max-width: 600px) 100vw"
            />

            <img
                src={mobileSrc}
                srcSet={`${mobileSrc2x} 2x, ${mobileSrc3x} 3x`}
                sizes="(max-width: 600px) 100vw"
                alt="background"
                className={styles.backgroundImage}
            />
        </picture>
    );
};
